import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DetailPicker from './DetailPicker';

const styles = () => ({
  root: {
    height: '100%',
  },
});

const BottomPart = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <DetailPicker className={classes.list} />
    </Box>
  );
};

BottomPart.defaultProps = {
  className: '',
};

BottomPart.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BottomPart);
